export const getFocusRingStyles = (outlineOffset = '2px') => ({
  '&:focus-visible': {
    outline: ({ palette }) => `2px solid ${palette.primary.main}`,
    outlineOffset,
  },
});

export const wrapperStyles = { mt: '4px' };

export const toggleStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '4px',
  color: 'text.secondary',
  ...getFocusRingStyles(),
};

export const getToggleIconStyles = isExpanded => ({
  display: 'flex',
  transform: isExpanded ? 'rotate(180deg)' : 'none',
  transition: 'transform 0.2s',
});

export const listStyles = {
  maxHeight: 180,
  overflowY: 'auto',
  mt: '4px',
};

export const showAllStyles = {
  mt: '4px',
  color: 'primary.main',
  borderRadius: '4px',
  ...getFocusRingStyles(),
};
